/* eslint-disable no-undef */
'use strict';

var _regeneratorRuntime = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _awaitAsyncGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _require = require('./http/fetch'),
    _fetch = _require.fetch,
    Request = _require.Request,
    Headers = _require.Headers;

var _require2 = require('./http/error'),
    TimeoutError = _require2.TimeoutError,
    HTTPError = _require2.HTTPError;

var merge = require('merge-options').bind({
  ignoreUndefined: true
});

var _require3 = require('iso-url'),
    URL = _require3.URL,
    URLSearchParams = _require3.URLSearchParams;

var TextDecoder = require('./text-decoder');

var _require4 = require('native-abort-controller'),
    AbortController = _require4.AbortController;

var anySignal = require('any-signal');
/**
 * @typedef {import('electron-fetch').Response} Response
 * @typedef {import('stream').Readable} NodeReadableStream
 * @typedef {import('stream').Duplex} NodeDuplexStream
 * @typedef {import('./types').HTTPOptions} HTTPOptions
 */

/**
 * @template TResponse
 * @param {Promise<TResponse>} promise
 * @param {number | undefined} ms
 * @param {AbortController} abortController
 * @returns {Promise<TResponse>}
 */


var timeout = function timeout(promise, ms, abortController) {
  if (ms === undefined) {
    return promise;
  }

  var start = Date.now();

  var timedOut = function timedOut() {
    var time = Date.now() - start;
    return time >= ms;
  };

  return new Promise(function (resolve, reject) {
    var timeoutID = setTimeout(function () {
      if (timedOut()) {
        reject(new TimeoutError());
        abortController.abort();
      }
    }, ms);
    /**
     * @param {(value: any) => void } next
     */

    var after = function after(next) {
      /**
       * @param {any} res
       */
      var fn = function fn(res) {
        clearTimeout(timeoutID);

        if (timedOut()) {
          reject(new TimeoutError());
          return;
        }

        next(res);
      };

      return fn;
    };

    promise.then(after(resolve), after(reject));
  });
};

var defaults = {
  throwHttpErrors: true,
  credentials: 'same-origin'
};

var HTTP =
/*#__PURE__*/
function () {
  /**
   *
   * @param {HTTPOptions} options
   */
  function HTTP() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, HTTP);

    /** @type {HTTPOptions} */
    this.opts = merge(defaults, options);
  }
  /**
   * Fetch
   *
   * @param {string | Request} resource
   * @param {HTTPOptions} options
   * @returns {Promise<Response>}
   */


  _createClass(HTTP, [{
    key: "fetch",
    value: function () {
      var _fetch2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(resource) {
        var options,
            opts,
            headers,
            url,
            searchParams,
            transformSearchParams,
            json,
            abortController,
            signal,
            response,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

                /** @type {HTTPOptions} */
                opts = merge(this.opts, options);
                headers = new Headers(opts.headers); // validate resource type

                if (!(typeof resource !== 'string' && !(resource instanceof URL || resource instanceof Request))) {
                  _context2.next = 5;
                  break;
                }

                throw new TypeError('`resource` must be a string, URL, or Request');

              case 5:
                url = new URL(resource.toString(), opts.base);
                searchParams = opts.searchParams, transformSearchParams = opts.transformSearchParams, json = opts.json;

                if (searchParams) {
                  if (typeof transformSearchParams === 'function') {
                    // @ts-ignore
                    url.search = transformSearchParams(new URLSearchParams(opts.searchParams));
                  } else {
                    // @ts-ignore
                    url.search = new URLSearchParams(opts.searchParams);
                  }
                }

                if (json) {
                  opts.body = JSON.stringify(opts.json);
                  headers.set('content-type', 'application/json');
                }

                abortController = new AbortController(); // @ts-ignore

                signal = anySignal([abortController.signal, opts.signal]);
                _context2.next = 13;
                return timeout(_fetch(url.toString(), _objectSpread({}, opts, {
                  signal: signal,
                  timeout: undefined,
                  headers: headers
                })), opts.timeout, abortController);

              case 13:
                response = _context2.sent;

                if (!(!response.ok && opts.throwHttpErrors)) {
                  _context2.next = 19;
                  break;
                }

                if (!opts.handleError) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 18;
                return opts.handleError(response);

              case 18:
                throw new HTTPError(response);

              case 19:
                response.iterator = function () {
                  return fromStream(response.body);
                };

                response.ndjson =
                /*#__PURE__*/
                _wrapAsyncGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee() {
                  var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _iteratorNormalCompletion = true;
                          _didIteratorError = false;
                          _context.prev = 2;
                          _iterator = _asyncIterator(ndjson(response.iterator()));

                        case 4:
                          _context.next = 6;
                          return _awaitAsyncGenerator(_iterator.next());

                        case 6:
                          _step = _context.sent;
                          _iteratorNormalCompletion = _step.done;
                          _context.next = 10;
                          return _awaitAsyncGenerator(_step.value);

                        case 10:
                          _value = _context.sent;

                          if (_iteratorNormalCompletion) {
                            _context.next = 23;
                            break;
                          }

                          chunk = _value;

                          if (!options.transform) {
                            _context.next = 18;
                            break;
                          }

                          _context.next = 16;
                          return options.transform(chunk);

                        case 16:
                          _context.next = 20;
                          break;

                        case 18:
                          _context.next = 20;
                          return chunk;

                        case 20:
                          _iteratorNormalCompletion = true;
                          _context.next = 4;
                          break;

                        case 23:
                          _context.next = 29;
                          break;

                        case 25:
                          _context.prev = 25;
                          _context.t0 = _context["catch"](2);
                          _didIteratorError = true;
                          _iteratorError = _context.t0;

                        case 29:
                          _context.prev = 29;
                          _context.prev = 30;

                          if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                            _context.next = 34;
                            break;
                          }

                          _context.next = 34;
                          return _awaitAsyncGenerator(_iterator.return());

                        case 34:
                          _context.prev = 34;

                          if (!_didIteratorError) {
                            _context.next = 37;
                            break;
                          }

                          throw _iteratorError;

                        case 37:
                          return _context.finish(34);

                        case 38:
                          return _context.finish(29);

                        case 39:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[2, 25, 29, 39], [30,, 34, 38]]);
                }));
                return _context2.abrupt("return", response);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetch(_x2) {
        return _fetch2.apply(this, arguments);
      }

      return fetch;
    }()
    /**
     * @param {string | Request} resource
     * @param {HTTPOptions} options
     * @returns {Promise<Response>}
     */

  }, {
    key: "post",
    value: function post(resource) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.fetch(resource, _objectSpread({}, options, {
        method: 'POST'
      }));
    }
    /**
     * @param {string | Request} resource
     * @param {HTTPOptions} options
     * @returns {Promise<Response>}
     */

  }, {
    key: "get",
    value: function get(resource) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.fetch(resource, _objectSpread({}, options, {
        method: 'GET'
      }));
    }
    /**
     * @param {string | Request} resource
     * @param {HTTPOptions} options
     * @returns {Promise<Response>}
     */

  }, {
    key: "put",
    value: function put(resource) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.fetch(resource, _objectSpread({}, options, {
        method: 'PUT'
      }));
    }
    /**
     * @param {string | Request} resource
     * @param {HTTPOptions} options
     * @returns {Promise<Response>}
     */

  }, {
    key: "delete",
    value: function _delete(resource) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.fetch(resource, _objectSpread({}, options, {
        method: 'DELETE'
      }));
    }
    /**
     * @param {string | Request} resource
     * @param {HTTPOptions} options
     * @returns {Promise<Response>}
     */

  }, {
    key: "options",
    value: function options(resource) {
      var _options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.fetch(resource, _objectSpread({}, _options, {
        method: 'OPTIONS'
      }));
    }
  }]);

  return HTTP;
}();
/**
 * Parses NDJSON chunks from an iterator
 *
 * @param {AsyncIterable<Uint8Array>} source
 * @returns {AsyncIterable<any>}
 */


var ndjson =
/*#__PURE__*/
function () {
  var _ref2 = _wrapAsyncGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(source) {
    var decoder, buf, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, chunk, lines, i, l;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            decoder = new TextDecoder();
            buf = '';
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _context3.prev = 4;
            _iterator2 = _asyncIterator(source);

          case 6:
            _context3.next = 8;
            return _awaitAsyncGenerator(_iterator2.next());

          case 8:
            _step2 = _context3.sent;
            _iteratorNormalCompletion2 = _step2.done;
            _context3.next = 12;
            return _awaitAsyncGenerator(_step2.value);

          case 12:
            _value2 = _context3.sent;

            if (_iteratorNormalCompletion2) {
              _context3.next = 30;
              break;
            }

            chunk = _value2;
            buf += decoder.decode(chunk, {
              stream: true
            });
            lines = buf.split(/\r?\n/);
            i = 0;

          case 18:
            if (!(i < lines.length - 1)) {
              _context3.next = 26;
              break;
            }

            l = lines[i].trim();

            if (!(l.length > 0)) {
              _context3.next = 23;
              break;
            }

            _context3.next = 23;
            return JSON.parse(l);

          case 23:
            i++;
            _context3.next = 18;
            break;

          case 26:
            buf = lines[lines.length - 1];

          case 27:
            _iteratorNormalCompletion2 = true;
            _context3.next = 6;
            break;

          case 30:
            _context3.next = 36;
            break;

          case 32:
            _context3.prev = 32;
            _context3.t0 = _context3["catch"](4);
            _didIteratorError2 = true;
            _iteratorError2 = _context3.t0;

          case 36:
            _context3.prev = 36;
            _context3.prev = 37;

            if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
              _context3.next = 41;
              break;
            }

            _context3.next = 41;
            return _awaitAsyncGenerator(_iterator2.return());

          case 41:
            _context3.prev = 41;

            if (!_didIteratorError2) {
              _context3.next = 44;
              break;
            }

            throw _iteratorError2;

          case 44:
            return _context3.finish(41);

          case 45:
            return _context3.finish(36);

          case 46:
            buf += decoder.decode();
            buf = buf.trim();

            if (!(buf.length !== 0)) {
              _context3.next = 51;
              break;
            }

            _context3.next = 51;
            return JSON.parse(buf);

          case 51:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[4, 32, 36, 46], [37,, 41, 45]]);
  }));

  return function ndjson(_x) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Stream to AsyncIterable
 *
 * @template TChunk
 * @param {ReadableStream<TChunk> | NodeReadableStream | null} source
 * @returns {AsyncIterable<TChunk>}
 */


var fromStream = function fromStream(source) {
  // Workaround for https://github.com/node-fetch/node-fetch/issues/766
  if (isNodeReadableStream(source)) {
    var iter = source[Symbol.asyncIterator]();
    return _defineProperty({}, Symbol.asyncIterator, function () {
      return {
        next: iter.next.bind(iter),
        return: function _return(value) {
          source.destroy();

          if (typeof iter.return === 'function') {
            return iter.return();
          }

          return Promise.resolve({
            done: true,
            value: value
          });
        }
      };
    });
  }

  if (isWebReadableStream(source)) {
    var reader = source.getReader();
    return _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4() {
      var _ref5, done, value;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;

            case 1:
              if (!true) {
                _context4.next = 14;
                break;
              }

              _context4.next = 4;
              return _awaitAsyncGenerator(reader.read());

            case 4:
              _ref5 = _context4.sent;
              done = _ref5.done;
              value = _ref5.value;

              if (!done) {
                _context4.next = 9;
                break;
              }

              return _context4.abrupt("return");

            case 9:
              if (!value) {
                _context4.next = 12;
                break;
              }

              _context4.next = 12;
              return value;

            case 12:
              _context4.next = 1;
              break;

            case 14:
              _context4.prev = 14;
              reader.releaseLock();
              return _context4.finish(14);

            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0,, 14, 17]]);
    }))();
  }

  if (isAsyncIterable(source)) {
    return source;
  }

  throw new TypeError('Body can\'t be converted to AsyncIterable');
};
/**
 * Check if it's an AsyncIterable
 *
 * @template {unknown} TChunk
 * @template {any} Other
 * @param {Other|AsyncIterable<TChunk>} value
 * @returns {value is AsyncIterable<TChunk>}
 */


var isAsyncIterable = function isAsyncIterable(value) {
  return typeof value === 'object' && value !== null && typeof
  /** @type {any} */
  value[Symbol.asyncIterator] === 'function';
};
/**
 * Check for web readable stream
 *
 * @template {unknown} TChunk
 * @template {any} Other
 * @param {Other|ReadableStream<TChunk>} value
 * @returns {value is ReadableStream<TChunk>}
 */


var isWebReadableStream = function isWebReadableStream(value) {
  return value && typeof
  /** @type {any} */
  value.getReader === 'function';
};
/**
 * @param {any} value
 * @returns {value is NodeReadableStream}
 */


var isNodeReadableStream = function isNodeReadableStream(value) {
  return Object.prototype.hasOwnProperty.call(value, 'readable') && Object.prototype.hasOwnProperty.call(value, 'writable');
};

HTTP.HTTPError = HTTPError;
HTTP.TimeoutError = TimeoutError;
HTTP.streamToAsyncIterator = fromStream;
/**
 * @param {string | Request} resource
 * @param {HTTPOptions} [options]
 * @returns {Promise<Response>}
 */

HTTP.post = function (resource, options) {
  return new HTTP(options).post(resource, options);
};
/**
 * @param {string | Request} resource
 * @param {HTTPOptions} [options]
 * @returns {Promise<Response>}
 */


HTTP.get = function (resource, options) {
  return new HTTP(options).get(resource, options);
};
/**
 * @param {string | Request} resource
 * @param {HTTPOptions} [options]
 * @returns {Promise<Response>}
 */


HTTP.put = function (resource, options) {
  return new HTTP(options).put(resource, options);
};
/**
 * @param {string | Request} resource
 * @param {HTTPOptions} [options]
 * @returns {Promise<Response>}
 */


HTTP.delete = function (resource, options) {
  return new HTTP(options).delete(resource, options);
};
/**
 * @param {string | Request} resource
 * @param {HTTPOptions} [options]
 * @returns {Promise<Response>}
 */


HTTP.options = function (resource, options) {
  return new HTTP(options).options(resource, options);
};

module.exports = HTTP;